const parseUserKeyName = 'Parse/routing-server/currentUser';

export const deleteUserInfoFromLocalStorage = async () => {
    return await localStorage.removeItem(parseUserKeyName)
}